'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const Zindexes = {
  closeButton: 1,
  supportButtons: 12,
  npsSurvey: 99,
  stickyHeader: 99,
  dropdownMenu: 900,
  blogDialogContainer: 901,
  asyncOverlay: 901,
  signUp: 949,
  universalNav: 950,
  universalTopbarMegaDropdown: 960,
  popover: 1002,
  editorErrorList: 1002,
  modalOverlay: 2e3,
  headerFixedPosition: 1e4,
  pageNotification: 10100,
  perfReport: 1e6,
  // To defeat the 1000200 of the social share dock
  fixedSurvey: 1000201
};

exports.Zindexes = Zindexes;
//# sourceMappingURL=Zindexes.cjs.js.map
